// External libraries
import { stripNonAlphaNum, stripNonDigits } from '@checkout/react-components';
const maskCpf = value => {
  if (!value) {
    return '';
  }

  const stripped = stripNonDigits(value);
  // CPF should be 11 digits
  const formatted = [
    ['', stripped.slice(0, 3)],
    ['.', stripped.slice(3, 6)],
    ['.', stripped.slice(6, 9)],
    ['-', stripped.slice(9, 11)],
  ]
    .map(([delimeter, value]) => {
      return value ? delimeter + value : '';
    })
    .join('');
  return formatted;
};

const demask = value => stripNonAlphaNum(value);

const maskingFunctionMap = {
  // this should be the default behavior if masking fn does not exist
  DEMASK: demask,
  CPF: maskCpf, // eslint-disable-line sort-keys
};

export { maskingFunctionMap };
